import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
export const HeroSection: React.FC = () => {
  const navigate = useNavigate();
  const headlineText = 'Your Premium Relief.';
  const words = headlineText.split(' ');
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: [0.25, 0.1, 0.25, 1]
      }
    }
  };
  return <section className="relative pt-32 pb-20 lg:pt-48 lg:pb-32 overflow-hidden bg-white" data-id="element-106">
      {/* Animated Background Elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-107">
        <motion.div animate={{
        y: [0, -20, 0],
        rotate: [0, 5, 0]
      }} transition={{
        duration: 8,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="absolute -top-[10%] -right-[10%] w-[50%] h-[50%] rounded-full bg-brand-primary/5 blur-3xl" data-id="element-108" />
        <motion.div animate={{
        y: [0, 30, 0],
        rotate: [0, -5, 0]
      }} transition={{
        duration: 10,
        repeat: Infinity,
        ease: 'easeInOut',
        delay: 1
      }} className="absolute top-[20%] -left-[10%] w-[40%] h-[40%] rounded-full bg-brand-accent/5 blur-3xl" data-id="element-109" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-110">
        <div className="text-center max-w-4xl mx-auto" data-id="element-111">
          <motion.div variants={containerVariants} initial="hidden" animate="visible" className="flex flex-wrap justify-center gap-x-3 mb-6" data-id="element-112">
            {words.map((word, index) => <motion.span key={index} variants={itemVariants} className={`text-5xl md:text-7xl font-extrabold tracking-tight ${word === 'Premium' || word === 'Relief.' ? 'text-brand-primary' : 'text-brand-text-dark'}`} data-id="element-113">
                {word}
              </motion.span>)}
          </motion.div>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.8
        }} className="text-lg md:text-xl text-brand-text-light mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-114">
            From diaspora payments to community fundraising, manage your entire
            financial life on one seamless platform.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 1
        }} className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-115">
            <button onClick={() => navigate('/login')} className="w-full sm:w-auto px-8 py-4 bg-brand-accent hover:bg-orange-400 text-white rounded-2xl font-bold text-lg transition-all shadow-lg shadow-brand-accent/30 hover:shadow-xl hover:-translate-y-0.5 flex items-center justify-center gap-2" data-id="element-116">
              Join the Waitlist <ArrowRight size={20} data-id="element-117" />
            </button>
            <button onClick={() => {
            document.getElementById('solutions')?.scrollIntoView({
              behavior: 'smooth'
            });
          }} className="w-full sm:w-auto px-8 py-4 bg-white border-2 border-gray-100 hover:border-brand-primary/30 hover:bg-gray-50 text-brand-text-dark rounded-2xl font-bold text-lg transition-all" data-id="element-118">
              Explore Solutions
            </button>
          </motion.div>
        </div>
      </div>
    </section>;
};